import type { NormalizedRunV2 } from './types.js';

export function cloudRunFingerprint(run: NormalizedRunV2): string {
  return JSON.stringify([
    run.startTime,
    run.buildId,
    run.character,
    run.ascension,
    run.playerCount,
    run.runTime,
    run.floor,
    run.status,
    run.players.map((player) => [player.character, player.deck.map((card) => [card.id, card.upgradeLevel]), player.relics.map((relic) => relic.id)])
  ]);
}
